import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Component({
  selector: 'molecule-menu-section',
  templateUrl: './menu-section.component.html',
  styleUrls: ['./menu-section.component.scss'],
})
export class MenuSectionComponent implements OnInit {
  @Input() sectionRoute?:string;
  @Input() sectionIcon: string = " ";
  @Input() sectionIconColor: string = " ";
  @Input() sectionTitle: string = " ";
  @Input() isDeployable: boolean = true;

  isOpen: boolean = false;

  constructor(private renderer: Renderer2, private element: ElementRef) {}

  ngOnInit() {
    if (this.sectionRoute) this.isDeployable = false;
  }

  onOpen(){
    this.isOpen = !this.isOpen;

    const parentElement = this.element.nativeElement.parentElement;

    if (this.isOpen) {
      this.renderer.addClass(parentElement, 'show');
    } else {
      this.renderer.removeClass(parentElement, 'show');
    }
  }

 }
